const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/utils/medicationUtils.ts';
import { assertNever } from './generalUtils';

export enum ImageContent {
    PackageBack,
    PackageFront,
    DosageFormBack,
    DosageFormFront,
}

type ImageSize = 'F' | 'M' | 'T';

export function getMedicationImageUrl(
    fkey: string | undefined,
    imageContent: ImageContent,
    imageSize: ImageSize = 'F'
) {
    if (!fkey) {
        return '';
    }
    const imageCode = fkey.replace(/^AGL0*/, '');

    // Early out
    if (!imageCode) {
        return '';
    }

    let imageView = '';

    switch (imageContent) {
        case ImageContent.PackageBack:
            imageView = 'PICBACK3D';
            break;
        case ImageContent.PackageFront:
            imageView = 'PICFRONT3D';
            break;
        case ImageContent.DosageFormBack:
            imageView = 'DOSEFORMBACK';
            break;
        case ImageContent.DosageFormFront:
            imageView = 'DOSEFORMFRONT';
            break;
        default:
            assertNever(imageContent);
    }
    return `https://documedis.hcisolutions.ch/2020-01/api/products/image/${imageView}/pharmacode/${imageCode}/${imageSize}`;
}
